import {useDispatch, useSelector} from 'react-redux';

import * as localizationKeys from '../../../consts/localization/localizationKeys';
import ModalTypes from '../../../enums/app/modalTypes';
import useDeviceName from '../../../hooks/useDeviceName';
import connectivityService from '../../../services/device/connectivityService';
import modalService from '../../../services/modalService';
import {setNotificationSuccess} from '../../../state/ducks/global';
import {makeSelectIsReconnectGuideEnabled} from '../../../state/selectors/global';
import useDeviceConnectionStatus from './useDeviceConnectionStatus';

const useHideReconnectionGuideModal = () => {
    const isReconnectGuideEnabled = useSelector(makeSelectIsReconnectGuideEnabled());
    const deviceName = useDeviceName();
    const dispatch = useDispatch();
    const isUsb = connectivityService.isUsb();
    const isDisabled = !(isUsb && isReconnectGuideEnabled);

    useDeviceConnectionStatus({
        onConnect: () => {
            modalService.hideModal(ModalTypes.RECONNECT_DEVICE_GUIDE);
        },
        onReconnect: () => {
            dispatch(
                setNotificationSuccess({
                    textKey: localizationKeys.DEVICE_RECONNECT_NOTIFICATION,
                    textFormatValues: deviceName,
                })
            );
        },
        isDisabled,
    });
};

export default useHideReconnectionGuideModal;
